import React, {useContext} from "react";
import Input from "../props/inputProp";
import { DeviceContext } from "../context/deviceContext";
import { AuctionSearchAndFilterContext } from "../context/auctionFilterContext";


export default function AuctionSearchAndFilter(props){

    const {isMobile} = useContext(DeviceContext);

    const {
        searchQuery,
        filterQueries,
        handleChange,
        handleFilterChange,
        handleFilteration,
        handleReset
    } = useContext(AuctionSearchAndFilterContext);  

    const{setFilteredProperties, properties} = props;


    return (
        
        <div className="searchAndFilter">

            {/* Search Container */}
            <div className="searchContainer">
                <span className="searchTitle">Enter a location</span>
                <Input 
                    className="search"
                    type="text"
                    name="searchQuery"
                    placeholder="e.g. London or LE3"
                    minLength="2"
                    autoCapitalize="off"
                    autoCorrect="off"
                    value={searchQuery}
                    onChange={handleChange}
                />
                
            </div>

            {/* Filters container */}

            <div className="filterContainer searchFilterContainer">
                {/* If the device is a mobile phone, only show the auctions tatus filter and the filter button
                In case if it is not, show the bedroom, price, reserve price, and auction status filter options. */}
                {isMobile ? (

                <>

                    <div className="filterQueries  maxBidsFilterContainer">
                        <span className="filterTitle">Max Bids</span>
                        <Input 
                            className="reservePriceFilter maxBidsFilter"
                            type="text"
                            name="bids"
                            placeholder="10"
                            minLength="1"
                            autoCapitalize="off"
                            autoCorrect="off"
                            value={filterQueries.bids}
                            onChange={handleFilterChange}
                        />
                    </div>

                    <div className="filterButton">
                        <button type="button" className="fbutton" onClick={() => handleFilteration(setFilteredProperties)}>
                            <div className="filter">
                                <span className="filterIcon"></span>
                                <div className="fTitle">Filter</div>
                            </div>
                        </button>
                    </div>
                </>
                ):(
                    <>

                        <div className="filterQueries bedroomFilter">
                            <span className="filterTitle">Min Bedrooms</span>
                            <Input 
                                className="bedFilter"
                                type="text"
                                name="beds"
                                placeholder="1"
                                minLength="1"
                                autoCapitalize="off"
                                autoCorrect="off"
                                value={filterQueries.beds}
                                onChange={handleFilterChange}
                            />
                        </div>

                        <div className="filterQueries priceFilterContainer">
                            <span className="filterTitle">Max Price</span>
                            <Input 
                                className="priceFilter"
                                type="text"
                                name="price"
                                placeholder="£3000"
                                minLength="1"
                                autoCapitalize="off"
                                autoCorrect="off"
                                value={filterQueries.price}
                                onChange={handleFilterChange}
                            />
                        </div>

                        <div className="filterQueries reservePriceFilterContainer">
                            <span className="filterTitle">Reserve Price</span>
                            <Input 
                                className="reservePriceFilter"
                                type="text"
                                name="reservePrice"
                                placeholder="Max reserve price eg. £1000"
                                minLength="1"
                                autoCapitalize="off"
                                autoCorrect="off"
                                value={filterQueries.reservePrice}
                                onChange={handleFilterChange}
                            />
                        </div>

                        <div className="filterQueries reservePriceFilterContainer maxBidsFilterContainer">
                            <span className="filterTitle">Max Bids</span>
                            <Input 
                                className="reservePriceFilter maxBidsFilter"
                                type="text"
                                name="bids"
                                placeholder="10"
                                minLength="1"
                                autoCapitalize="off"
                                autoCorrect="off"
                                value={filterQueries.bids}
                                onChange={handleFilterChange}
                            />
                        </div>


                        <div className="filterButton">
                            <button type="button" className="fbutton" onClick={() => handleFilteration(setFilteredProperties)}>
                                <div className="filter">
                                    <span className="filterIcon"></span>
                                    <div className="fTitle">Filter</div>
                                </div>
                            </button>

                            <button type="button" className="fbutton resetFilterButton" onClick={()=> handleReset(setFilteredProperties, properties)}>
                                <div className="filter">
                                    <span className="resetIcon"></span>
                                    
                                </div>
                            </button>
                        </div>
                </>
            )}
            </div>
        </div> 
        
    )
}

